module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Mendip Handyman","short_name":"Mendip Handyman","description":"Property restoration and renovation specialists in Somerset.","lang":"en-GB","start_url":"/","background_color":"#FAF8F3","theme_color":"#FAF8F3","display":"standalone","icon":"src/images/icon.svg","icon_options":{"purpose":"any maskable"},"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"e61913269e2291ed7f23ffe00ce8c399"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
